import { addGETParams } from '../../config'
import ax from '../api'

/*
 * getCardData - Retrieve a specific card data item from the server
 * @param {object} params - Additional parameters to send to the server
 * @returns {object} The response from the server containing the card data item
 */
export const getCardData = async (params) => {
	// TODO: remove simulateApiCall, instead use  the actual API endpoint
	// return simulateApiCall(DASHBOARD_CARD_DATA)
	const _url = addGETParams(`/management/dashboard/card-data.php`, params)
	const { data } = await ax.get(_url)
	return data
}

/*
 * getUserProgressData - Retrieve user progress information from the server
 * @param {object} params - Additional parameters to send to the server
 * @returns {object} The response from the server containing the user progress data
 */
export const getUserProgressData = async () => {
	// TODO: remove simulateApiCall, instead use  the actual API endpoint
	return simulateApiCall(DASHBOARD_USER_PROGRESS_DATA)
	// const _url = addGETParams(`/management/user/progress.php`, params)
	// const { data } = await ax.get(_url)
	// return data
}

/*
 * getOverviewData - Retrieve an overview of dashboard data from the server
 * @param {object} params - Additional parameters to send to the server
 * @returns {object} The response from the server containing the overview data
 */
export const getOverviewData = async () => {
	// TODO: remove simulateApiCall, instead use  the actual API endpoint
	return simulateApiCall(DASHBOARD_OVERVIEW_DATA)
	// const _url = addGETParams(`/dashboard/overview.php`, params)
	// const { data } = await ax.get(_url)
	// return data
}

// Mock data
const DASHBOARD_USER_PROGRESS_DATA = [
	{
		user_id: 1,
		user_name: 'Siddharth',
		total_sprint_completed: 10,
		total_worked_hours: 111,
		total_contract_hours: 160
	},
	{
		user_id: 2,
		user_name: 'Daniel',
		total_sprint_completed: 10,
		total_worked_hours: 20,
		total_contract_hours: 10
	},
	{
		user_id: 3,
		user_name: 'Adarsh',
		total_sprint_completed: 10,
		total_worked_hours: 111,
		total_contract_hours: 160
	}
]

const DASHBOARD_OVERVIEW_DATA = {
	sprints: [
		{
			id: 1,
			name: 'Sprint 1',
			deadline: '2024-10-31',
			status: 'completed'
		},
		{
			id: 2,
			name: 'Sprint 2',
			deadline: '2024-11-15',
			status: 'in progress'
		}
	],
	requests: [
		{ id: 1, request: 'Update API', status: 'not_read' },
		{ id: 2, request: 'Bug Fix', status: 'completed' }
	]
}

// Mock API functions
const simulateApiCall = (data) => {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve({ data })
		}, 1000) // Simulate network delay
	})
}
